import { FirestoreRepository } from '@upadelmatch/core'
import { PlayerPublicSchema } from '@/core/models/player-public'

// `players_public/{uid}` — read-only projection of other players' public
// facts (spec/06). Written exclusively by Cloud Functions; the client only
// ever reads (rules enforce write: false).
class PlayersPublicRepository extends FirestoreRepository<typeof PlayerPublicSchema> {
  constructor() {
    super('players_public', PlayerPublicSchema)
  }
}

export const playersPublicRepository = new PlayersPublicRepository()
